import React from "react";
import mime from "mime/lite";
import { FileIcon, defaultStyles } from "react-file-icon";
import YouTubeIcon from "@mui/icons-material/YouTube";

export default function FileTypeIcon({ file, size = 32 }) {
  const ext = file.mimeType ? mime.getExtension(file.mimeType) : "txt";
  if (file.type === "youtube") {
    return (
      <YouTubeIcon
        sx={{
          width: `${size}px`,
        }}
      />
    );
  }

  if (file.type === "image") {
    return (
      <img
        alt="image"
        src={file.imageUrl}
        style={{
          width: `${size}px`,
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: `${size}px`,
      }}
    >
      <FileIcon extension={ext} {...defaultStyles[ext]} />
    </div>
  );
}
